import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';  
import { HrSidebarComponent } from './master/hr-sidebar/hr-sidebar.component';
import { PoSidebarComponent } from './master/po-sidebar/po-sidebar.component';
import { TimesheetSidebarComponent } from './master/timesheet-sidebar/timesheet-sidebar.component';
import { InvoiceSidebarComponent } from './master/invoice-sidebar/invoice-sidebar.component';
import { SowSidebarComponent } from './master/sow-sidebar/sow-sidebar.component';
import { AdminSidebarComponent } from './master/admin-sidebar/admin-sidebar.component';
import { LendingComponent } from './master/lending/lending.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; 
import { MatTooltipModule } from '@angular/material/tooltip';
import { VendorSidebarComponent } from './master/vendor-sidebar/vendor-sidebar.component';
import { ClientSidebarComponent } from './master/client-sidebar/client-sidebar.component';
 
@NgModule({
  declarations: [
    HrSidebarComponent,
    PoSidebarComponent,
    TimesheetSidebarComponent,
    InvoiceSidebarComponent,
    SowSidebarComponent,
    AdminSidebarComponent,
    VendorSidebarComponent,
    LendingComponent,
    ClientSidebarComponent
 ],
  imports: [
    CommonModule,
    RouterModule,
    BrowserAnimationsModule, 
    MatTooltipModule
],
  exports: [
    HrSidebarComponent,
    PoSidebarComponent,
    AdminSidebarComponent,
    TimesheetSidebarComponent,
    InvoiceSidebarComponent,
    VendorSidebarComponent,
    LendingComponent,
    ClientSidebarComponent
  ]
})
export class MasterModule { }
